import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-[100] bg-background flex flex-col"
}
const _hoisted_2 = { class: "h-14 border-b px-6 py-3 flex items-center justify-between shrink-0" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "flex items-center gap-2" }
const _hoisted_5 = { class: "flex-1 min-h-0 flex" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col items-center py-2"
}
const _hoisted_7 = {
  key: 1,
  class: "p-3 border-b space-y-2"
}
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "flex gap-2" }
const _hoisted_10 = {
  key: 2,
  class: "flex-1 overflow-auto"
}
const _hoisted_11 = {
  key: 0,
  class: "flex items-center justify-center py-8"
}
const _hoisted_12 = {
  key: 1,
  class: "py-8 text-center px-4"
}
const _hoisted_13 = {
  key: 2,
  class: "py-8 text-center"
}
const _hoisted_14 = {
  key: 3,
  class: "divide-y"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "flex-1 min-w-0" }
const _hoisted_17 = { class: "text-sm font-medium truncate" }
const _hoisted_18 = { class: "flex items-center gap-1.5 text-xs text-muted-foreground mt-0.5" }
const _hoisted_19 = {
  key: 0,
  class: "flex items-center gap-0.5"
}
const _hoisted_20 = { class: "flex items-center gap-1.5 text-[11px] text-muted-foreground/70 mt-0.5" }
const _hoisted_21 = { class: "flex-1 flex flex-col min-w-0" }
const _hoisted_22 = {
  key: 0,
  class: "flex-1 flex items-center justify-center"
}
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "px-6 py-3 border-b shrink-0" }
const _hoisted_25 = { class: "flex items-start gap-3" }
const _hoisted_26 = { class: "flex-1 min-w-0" }
const _hoisted_27 = { class: "text-lg font-semibold flex items-center gap-2" }
const _hoisted_28 = { class: "flex items-center gap-1 mt-0.5 text-xs text-muted-foreground/70" }
const _hoisted_29 = { class: "font-mono text-[11px]" }
const _hoisted_30 = { class: "flex items-center gap-3 mt-1 text-sm text-muted-foreground" }
const _hoisted_31 = { class: "flex items-center gap-1" }
const _hoisted_32 = { class: "flex items-center gap-1.5" }
const _hoisted_33 = { class: "flex items-center gap-1" }
const _hoisted_34 = {
  key: 0,
  class: "flex items-center gap-1"
}
const _hoisted_35 = {
  key: 1,
  class: "text-xs"
}
const _hoisted_36 = { class: "px-6 py-2 border-b shrink-0" }
const _hoisted_37 = {
  key: 0,
  class: "px-6 py-3 border-b shrink-0 bg-muted/30"
}
const _hoisted_38 = {
  key: 0,
  class: "flex items-center gap-3"
}
const _hoisted_39 = { class: "h-9 w-9 rounded-full bg-primary/10 flex items-center justify-center shrink-0" }
const _hoisted_40 = {
  key: 1,
  class: "flex items-center gap-3"
}
const _hoisted_41 = { class: "h-9 w-9 rounded-full bg-destructive/10 flex items-center justify-center shrink-0" }
const _hoisted_42 = { class: "flex-1 min-w-0" }
const _hoisted_43 = { class: "text-xs text-muted-foreground" }
const _hoisted_44 = {
  key: 2,
  class: "flex items-center gap-3"
}
const _hoisted_45 = { class: "flex items-center gap-1.5 shrink-0" }
const _hoisted_46 = { class: "flex-1 min-w-0 flex items-center gap-3" }
const _hoisted_47 = { class: "text-xs text-muted-foreground tabular-nums shrink-0" }
const _hoisted_48 = {
  key: 1,
  class: "px-6 py-3 border-b shrink-0"
}
const _hoisted_49 = {
  key: 0,
  class: "flex items-center justify-between"
}
const _hoisted_50 = { class: "flex items-center gap-2 text-sm text-muted-foreground" }
const _hoisted_51 = {
  key: 1,
  class: "flex items-center gap-3"
}
const _hoisted_52 = { class: "h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center shrink-0" }
const _hoisted_53 = { key: 2 }
const _hoisted_54 = { class: "flex items-center justify-between mb-1" }
const _hoisted_55 = { class: "flex items-center gap-1.5" }
const _hoisted_56 = {
  key: 0,
  class: "mt-2 rounded-md px-4 py-3 max-h-72 overflow-y-auto"
}
const _hoisted_57 = { class: "prose prose-sm dark:prose-invert max-w-none text-sm" }
const _hoisted_58 = { class: "mt-2 text-[11px] text-muted-foreground/60" }
const _hoisted_59 = {
  key: 3,
  class: "mt-2 text-sm text-destructive"
}
const _hoisted_60 = { class: "flex-1 overflow-auto px-6 py-4" }
const _hoisted_61 = {
  key: 0,
  class: "flex flex-col items-center py-2"
}
const _hoisted_62 = {
  key: 1,
  class: "h-full flex flex-col"
}
const _hoisted_63 = { class: "flex items-center justify-between px-4 py-2 border-b shrink-0" }
const _hoisted_64 = { class: "flex-1 overflow-auto px-4 py-4" }
const _hoisted_65 = { class: "border-t shrink-0" }
const _hoisted_66 = { class: "flex items-center gap-2" }
const _hoisted_67 = {
  key: 0,
  class: "border-t px-4 py-3 space-y-2 max-h-64 overflow-y-auto"
}
const _hoisted_68 = { class: "relative" }
const _hoisted_69 = {
  key: 0,
  class: "flex items-center justify-center py-4"
}
const _hoisted_70 = {
  key: 1,
  class: "py-4 text-center"
}
const _hoisted_71 = {
  key: 2,
  class: "divide-y"
}
const _hoisted_72 = ["onClick"]
const _hoisted_73 = { class: "flex-1 min-w-0" }
const _hoisted_74 = { class: "text-sm font-medium truncate" }
const _hoisted_75 = { class: "text-[11px] text-muted-foreground" }
const _hoisted_76 = { class: "border-t shrink-0" }
const _hoisted_77 = { class: "flex items-center gap-2" }
const _hoisted_78 = {
  key: 0,
  class: "border-t px-4 py-3 max-h-72 overflow-y-auto"
}

import { ref, computed, watch, onMounted, onUnmounted } from 'vue'
import { useDocumentViewer } from '@/composables/useDocumentViewer'
import { useDocumentsStore } from '@/views/Documents/store'
import { useUsersStore } from '@/views/Users/store'
import { useAuthStore } from '@/stores/auth'
import { useMarkdownPdf } from '@/composables/useMarkdownPdf'
import { synthesizeSpeech } from '@/services/ttsService'
import { MdPreview } from 'md-editor-v3'
import 'md-editor-v3/lib/preview.css'
import type { Document, DocumentEntityType, DocumentType } from '@/types'
import { formatDate, getInitials } from '@/utils/formatters'

import CommentsList from '@/views/Comments/components/CommentsList.vue'
import DocumentReactions from '@/views/Documents/components/DocumentReactions.vue'
import DocumentMarkdownView from '@/views/Documents/components/DocumentMarkdownView.vue'

import { Button } from '@/components/ui/button'
import { Badge } from '@/components/ui/badge'
import { Input } from '@/components/ui/input'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'
import { ScrollArea } from '@/components/ui/scroll-area'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import {
  FileText,
  Lock,
  Calendar,
  Hash,
  Download,
  Loader2,
  Eye,
  Minus,
  X,
  Search,
  Copy,
  Pencil,
  PanelLeftClose,
  PanelLeftOpen,
  PanelRightClose,
  PanelRightOpen,
  Headphones,
  Play,
  Pause,
  Square,
  Volume2,
  Sparkles,
  RefreshCw,
  CheckCircle,
  AlertTriangle,
  ChevronDown,
  ChevronUp,
} from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'DocumentViewerPanel',
  setup(__props) {

const {
  isOpen,
  currentDocumentId,
  currentDocument,
  close,
  minimize,
  setCurrentDocument,
  requestEdit,
} = useDocumentViewer()

const documentsStore = useDocumentsStore()
const usersStore = useUsersStore()
const authStore = useAuthStore()

// Mobile detection
const isMobile = ref(window.innerWidth < 768)
const onResize = () => { isMobile.value = window.innerWidth < 768 }
onMounted(() => window.addEventListener('resize', onResize))
onUnmounted(() => window.removeEventListener('resize', onResize))

// Search state
const searchQuery = ref('')
const entityFilter = ref<string>('all')
const searchPanelCollapsed = ref(isMobile.value)
const commentsPanelCollapsed = ref(isMobile.value)
const searchResults = ref<Document[]>([])
const isSearching = ref(false)
const hasSearched = ref(false)

const entityTypeOptions: { value: string; label: string }[] = [
  { value: 'all', label: 'Todas las entidades' },
  { value: 'project', label: 'Proyectos' },
  { value: 'requirement', label: 'Requerimientos' },
  { value: 'epic', label: 'Epicas' },
  { value: 'ticket', label: 'Tickets' },
  { value: 'application', label: 'Aplicaciones' },
  { value: 'meeting', label: 'Reuniones' },
  { value: 'petition', label: 'Peticiones' },
]

const documentTypeLabels: Record<DocumentType, string> = {
  scope: 'Alcance',
  architecture: 'Arquitectura',
  specifications: 'Especificaciones',
  manual: 'Manual',
  other: 'Otro',
}

const documentTypeColors: Record<DocumentType, string> = {
  scope: 'bg-blue-500',
  architecture: 'bg-purple-500',
  specifications: 'bg-green-500',
  manual: 'bg-orange-500',
  other: 'bg-gray-500',
}

const entityTypeLabels: Record<string, string> = {
  project: 'Proyecto',
  requirement: 'Requerimiento',
  epic: 'Epica',
  ticket: 'Ticket',
  application: 'Aplicacion',
  meeting: 'Reunion',
  petition: 'Peticion',
}

// Load document if opened by ID (e.g. from URL)
watch(
  [isOpen, currentDocumentId],
  async ([open, docId]) => {
    if (open && docId && !currentDocument.value) {
      const doc = await documentsStore.fetchDocumentById(docId)
      if (doc) {
        setCurrentDocument(doc)
        documentsStore.incrementViewCount(doc.id)
      }
    }
    if (open && currentDocument.value) {
      documentsStore.incrementViewCount(currentDocument.value.id)
    }
  },
  { immediate: true },
)

// Reset search state when panel closes, collapse panels on mobile when opening
watch(isOpen, (open) => {
  if (!open) {
    hasSearched.value = false
    searchResults.value = []
    searchQuery.value = ''
    entityFilter.value = 'all'
  } else if (isMobile.value) {
    searchPanelCollapsed.value = true
    commentsPanelCollapsed.value = true
  }
})

const authorName = computed(() => {
  if (!currentDocument.value) return ''
  const user = usersStore.users.find((u) => u.id === currentDocument.value?.createdBy)
  return user?.displayName || 'Usuario desconocido'
})

const authorUser = computed(() => {
  if (!currentDocument.value) return null
  return usersStore.users.find((u) => u.id === currentDocument.value?.createdBy) || null
})

const updatedByName = computed(() => {
  if (!currentDocument.value) return ''
  const user = usersStore.users.find((u) => u.id === currentDocument.value?.updatedBy)
  return user?.displayName || 'Usuario desconocido'
})

// PDF
const pdfMarkdown = computed(() => currentDocument.value?.content || '')
const pdfFilename = computed(() => currentDocument.value?.title || 'documento')
const pdfDocId = computed(() => currentDocument.value?.id || '')
const { isGenerating: isGeneratingPdf, downloadPdf } = useMarkdownPdf(pdfMarkdown, pdfFilename, pdfDocId)

// Copilot Summary
const summaryIsGenerating = ref(false)
const summaryError = ref<string | null>(null)
const summaryCollapsed = ref(false)

const hasSummary = computed(() => !!currentDocument.value?.copilotSummary?.content)
const summaryIsStale = computed(() => currentDocument.value?.copilotSummary?.isStale ?? false)
// ~4 chars per token for Spanish; 10k tokens ≈ 40k chars
const contentTooLong = computed(() => (currentDocument.value?.content?.length ?? 0) > 40000)

const handleGenerateSummary = async () => {
  if (!currentDocument.value) return
  summaryIsGenerating.value = true
  summaryError.value = null
  try {
    await documentsStore.generateSummary(currentDocument.value.id)
    // Refresh the document to get updated copilotSummary
    const updated = await documentsStore.fetchDocumentById(currentDocument.value.id)
    if (updated) setCurrentDocument(updated)
  } catch (error) {
    summaryError.value = error instanceof Error ? error.message : 'Error al generar resumen'
  } finally {
    summaryIsGenerating.value = false
  }
}

const handleConfirmSummary = async () => {
  if (!currentDocument.value) return
  try {
    await documentsStore.confirmSummary(currentDocument.value.id)
    // Update local view
    if (currentDocument.value.copilotSummary) {
      setCurrentDocument({
        ...currentDocument.value,
        copilotSummary: {
          ...currentDocument.value.copilotSummary,
          isStale: false,
          generatedByVersion: currentDocument.value.version,
        },
      })
    }
  } catch { /* ignore */ }
}

// TTS Audio Player
const ttsAudioUrl = ref<string | null>(null)
const ttsAudio = ref<HTMLAudioElement | null>(null)
const ttsIsLoading = ref(false)
const ttsIsPlaying = ref(false)
const ttsShowPlayer = ref(false)
const ttsCurrentTime = ref(0)
const ttsDuration = ref(0)
const ttsError = ref<string | null>(null)

const ttsFormattedTime = computed(() => {
  const format = (s: number) => {
    const m = Math.floor(s / 60)
    const sec = Math.floor(s % 60)
    return `${m}:${sec.toString().padStart(2, '0')}`
  }
  return `${format(ttsCurrentTime.value)} / ${format(ttsDuration.value)}`
})

const ttsProgress = computed(() => {
  if (ttsDuration.value === 0) return 0
  return (ttsCurrentTime.value / ttsDuration.value) * 100
})

const startTts = async () => {
  if (!currentDocument.value?.content) return
  ttsShowPlayer.value = true
  ttsIsLoading.value = true
  ttsError.value = null

  // Cleanup previous
  if (ttsAudio.value) {
    ttsAudio.value.pause()
    ttsAudio.value = null
  }
  if (ttsAudioUrl.value) {
    URL.revokeObjectURL(ttsAudioUrl.value)
    ttsAudioUrl.value = null
  }

  try {
    const blob = await synthesizeSpeech(currentDocument.value.content, 'es', 'md')
    const url = URL.createObjectURL(blob)
    ttsAudioUrl.value = url

    const audio = new Audio(url)
    ttsAudio.value = audio

    audio.addEventListener('loadedmetadata', () => {
      ttsDuration.value = audio.duration
    })
    audio.addEventListener('timeupdate', () => {
      ttsCurrentTime.value = audio.currentTime
    })
    audio.addEventListener('ended', () => {
      ttsIsPlaying.value = false
      ttsCurrentTime.value = 0
    })
    audio.addEventListener('error', () => {
      ttsError.value = 'Error al reproducir audio'
      ttsIsPlaying.value = false
    })

    await audio.play()
    ttsIsPlaying.value = true
  } catch (error) {
    ttsError.value = error instanceof Error ? error.message : 'Error al generar audio'
  } finally {
    ttsIsLoading.value = false
  }
}

const togglePlayPause = () => {
  if (!ttsAudio.value) return
  if (ttsIsPlaying.value) {
    ttsAudio.value.pause()
    ttsIsPlaying.value = false
  } else {
    ttsAudio.value.play()
    ttsIsPlaying.value = true
  }
}

const stopTts = () => {
  if (ttsAudio.value) {
    ttsAudio.value.pause()
    ttsAudio.value.currentTime = 0
    ttsIsPlaying.value = false
    ttsCurrentTime.value = 0
  }
}

const closeTtsPlayer = () => {
  stopTts()
  ttsShowPlayer.value = false
  if (ttsAudioUrl.value) {
    URL.revokeObjectURL(ttsAudioUrl.value)
    ttsAudioUrl.value = null
  }
  ttsAudio.value = null
  ttsError.value = null
}

const seekTts = (event: MouseEvent) => {
  if (!ttsAudio.value || ttsDuration.value === 0) return
  const target = event.currentTarget as HTMLElement
  const rect = target.getBoundingClientRect()
  const x = event.clientX - rect.left
  const pct = x / rect.width
  ttsAudio.value.currentTime = pct * ttsDuration.value
}

// Cleanup TTS when document changes or panel closes
watch([isOpen, currentDocumentId], () => {
  closeTtsPlayer()
})

const copyDocumentId = async () => {
  if (!currentDocument.value) return
  try {
    await navigator.clipboard.writeText(currentDocument.value.id)
  } catch { /* ignore */ }
}

const doSearch = async () => {
  isSearching.value = true
  hasSearched.value = true
  try {
    const filter = entityFilter.value === 'all' ? undefined : entityFilter.value as DocumentEntityType
    searchResults.value = await documentsStore.searchDocuments(searchQuery.value || undefined, filter)
  } finally {
    isSearching.value = false
  }
}

const selectDocument = (doc: Document) => {
  setCurrentDocument(doc)
  const { open } = useDocumentViewer()
  open(doc)
}

const getDocAuthor = (userId: string): string => {
  const user = usersStore.users.find((u) => u.id === userId)
  return user?.displayName || 'Desconocido'
}

onMounted(async () => {
  if (usersStore.users.length === 0) {
    await usersStore.fetchUsers()
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, {
      "enter-active-class": "transition-all duration-300 ease-out",
      "leave-active-class": "transition-all duration-200 ease-in",
      "enter-from-class": "opacity-0",
      "enter-to-class": "opacity-100",
      "leave-from-class": "opacity-100",
      "leave-to-class": "opacity-0"
    }, {
      default: _withCtx(() => [
        (_unref(isOpen))
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _createVNode(_unref(FileText), { class: "h-5 w-5" }),
                  _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "text-lg font-semibold" }, "Visor de Documentos", -1)),
                  (_unref(currentDocument))
                    ? (_openBlock(), _createBlock(_unref(Badge), {
                        key: 0,
                        variant: "outline"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_unref(currentDocument).title), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  (_unref(currentDocument))
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 0,
                        variant: "outline",
                        size: "sm",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(requestEdit)(_unref(currentDocument)!)))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Pencil), { class: "h-4 w-4 mr-1" }),
                          _cache[13] || (_cache[13] = _createTextVNode(" Editar ", -1))
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_unref(currentDocument) && !ttsShowPlayer.value && _unref(authStore).isModuleEnabled('voiceNotes'))
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 1,
                        variant: "outline",
                        size: "sm",
                        onClick: startTts,
                        disabled: ttsIsLoading.value
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(Headphones), { class: "h-4 w-4 mr-1" }),
                          _cache[14] || (_cache[14] = _createTextVNode(" Escuchar ", -1))
                        ]),
                        _: 1
                      }, 8, ["disabled"]))
                    : _createCommentVNode("", true),
                  (_unref(currentDocument))
                    ? (_openBlock(), _createBlock(_unref(Button), {
                        key: 2,
                        variant: "outline",
                        size: "sm",
                        onClick: _unref(downloadPdf),
                        disabled: _unref(isGeneratingPdf)
                      }, {
                        default: _withCtx(() => [
                          (_unref(isGeneratingPdf))
                            ? (_openBlock(), _createBlock(_unref(Loader2), {
                                key: 0,
                                class: "h-4 w-4 mr-1 animate-spin"
                              }))
                            : (_openBlock(), _createBlock(_unref(Download), {
                                key: 1,
                                class: "h-4 w-4 mr-1"
                              })),
                          _cache[15] || (_cache[15] = _createTextVNode(" PDF ", -1))
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    title: "Minimizar",
                    onClick: _unref(minimize)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(Minus), { class: "h-4 w-4" })
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_unref(Button), {
                    variant: "ghost",
                    size: "icon",
                    title: "Cerrar",
                    onClick: _unref(close)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(X), { class: "h-4 w-4" })
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!isMobile.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["shrink-0 border-r flex flex-col transition-all duration-200", searchPanelCollapsed.value ? 'w-10' : 'w-[320px]'])
                    }, [
                      (searchPanelCollapsed.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_unref(Button), {
                              variant: "ghost",
                              size: "icon",
                              class: "h-8 w-8",
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (searchPanelCollapsed.value = false)),
                              title: "Expandir búsqueda"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(PanelLeftOpen), { class: "h-4 w-4" })
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (!searchPanelCollapsed.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_unref(Search), { class: "absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" }),
                              _createVNode(_unref(Input), {
                                modelValue: searchQuery.value,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchQuery).value = $event)),
                                placeholder: "Buscar documentos...",
                                class: "pl-8 h-8 text-sm",
                                onKeydown: _withKeys(doSearch, ["enter"])
                              }, null, 8, ["modelValue"])
                            ]),
                            _createVNode(_unref(Select), {
                              modelValue: entityFilter.value,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((entityFilter).value = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectTrigger), { class: "h-8 text-sm" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(SelectValue))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SelectContent), { class: "z-[200]" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(entityTypeOptions, (opt) => {
                                      return _createVNode(_unref(SelectItem), {
                                        key: opt.value,
                                        value: opt.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(opt.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"])
                                    }), 64))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createElementVNode("div", _hoisted_9, [
                              _createVNode(_unref(Button), {
                                size: "sm",
                                class: "flex-1 h-8",
                                onClick: doSearch,
                                disabled: isSearching.value
                              }, {
                                default: _withCtx(() => [
                                  (isSearching.value)
                                    ? (_openBlock(), _createBlock(_unref(Loader2), {
                                        key: 0,
                                        class: "h-3.5 w-3.5 mr-1.5 animate-spin"
                                      }))
                                    : (_openBlock(), _createBlock(_unref(Search), {
                                        key: 1,
                                        class: "h-3.5 w-3.5 mr-1.5"
                                      })),
                                  _cache[16] || (_cache[16] = _createTextVNode(" Buscar ", -1))
                                ]),
                                _: 1
                              }, 8, ["disabled"]),
                              _createVNode(_unref(Button), {
                                variant: "ghost",
                                size: "icon",
                                class: "h-8 w-8 shrink-0",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (searchPanelCollapsed.value = true)),
                                title: "Contraer búsqueda"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(PanelLeftClose), { class: "h-4 w-4" })
                                ]),
                                _: 1
                              })
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (!searchPanelCollapsed.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            (isSearching.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createVNode(_unref(Loader2), { class: "h-5 w-5 animate-spin text-muted-foreground" })
                                ]))
                              : (!hasSearched.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createVNode(_unref(Search), { class: "h-8 w-8 text-muted-foreground mx-auto mb-2" }),
                                    _cache[17] || (_cache[17] = _createElementVNode("p", { class: "text-sm text-muted-foreground" }, "Usa los filtros y presiona Buscar", -1))
                                  ]))
                                : (searchResults.value.length === 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _createVNode(_unref(FileText), { class: "h-8 w-8 text-muted-foreground mx-auto mb-2" }),
                                      _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-sm text-muted-foreground" }, "Sin resultados", -1))
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (doc) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: doc.id,
                                          class: _normalizeClass(["w-full text-left px-3 py-2.5 hover:bg-muted/50 transition-colors flex items-start gap-2.5", { 'bg-muted': _unref(currentDocument)?.id === doc.id }]),
                                          onClick: ($event: any) => (selectDocument(doc))
                                        }, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["h-8 w-8 rounded flex items-center justify-center text-white shrink-0 mt-0.5", documentTypeColors[doc.type]])
                                          }, [
                                            _createVNode(_unref(FileText), { class: "h-4 w-4" })
                                          ], 2),
                                          _createElementVNode("div", _hoisted_16, [
                                            _createElementVNode("p", _hoisted_17, _toDisplayString(doc.title), 1),
                                            _createElementVNode("div", _hoisted_18, [
                                              _createVNode(_unref(Badge), {
                                                variant: "outline",
                                                class: "text-[10px] px-1 py-0"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(documentTypeLabels[doc.type]), 1)
                                                ]),
                                                _: 2
                                              }, 1024),
                                              _createElementVNode("span", null, "v" + _toDisplayString(doc.version), 1),
                                              (!doc.isPublic)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                                    _createVNode(_unref(Lock), { class: "h-2.5 w-2.5" })
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_20, [
                                              _createElementVNode("span", null, _toDisplayString(entityTypeLabels[doc.entityType] || doc.entityType), 1),
                                              _cache[19] || (_cache[19] = _createElementVNode("span", null, "·", -1)),
                                              _createElementVNode("span", null, _toDisplayString(getDocAuthor(doc.updatedBy)), 1),
                                              _cache[20] || (_cache[20] = _createElementVNode("span", null, "·", -1)),
                                              _createElementVNode("span", null, _toDisplayString(_unref(formatDate)(doc.updatedAt)), 1)
                                            ])
                                          ])
                                        ], 10, _hoisted_15))
                                      }), 128))
                                    ]))
                          ]))
                        : _createCommentVNode("", true)
                    ], 2))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_21, [
                  (!_unref(currentDocument))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createVNode(_unref(FileText), { class: "h-12 w-12 text-muted-foreground mx-auto mb-3" }),
                          _cache[21] || (_cache[21] = _createElementVNode("p", { class: "text-muted-foreground" }, "Selecciona un documento para visualizar", -1))
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", {
                              class: _normalizeClass(["h-10 w-10 rounded flex items-center justify-center text-white shrink-0", documentTypeColors[_unref(currentDocument).type]])
                            }, [
                              _createVNode(_unref(FileText), { class: "h-5 w-5" })
                            ], 2),
                            _createElementVNode("div", _hoisted_26, [
                              _createElementVNode("h2", _hoisted_27, [
                                _createTextVNode(_toDisplayString(_unref(currentDocument).title) + " ", 1),
                                (!_unref(currentDocument).isPublic)
                                  ? (_openBlock(), _createBlock(_unref(Badge), {
                                      key: 0,
                                      variant: "secondary",
                                      class: "text-xs"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Lock), { class: "h-3 w-3 mr-1" }),
                                        _cache[22] || (_cache[22] = _createTextVNode(" Interno ", -1))
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _createElementVNode("span", _hoisted_29, _toDisplayString(_unref(currentDocument).id), 1),
                                _createElementVNode("button", {
                                  class: "inline-flex items-center justify-center h-4 w-4 rounded hover:bg-muted transition-colors",
                                  title: "Copiar ID",
                                  onClick: copyDocumentId
                                }, [
                                  _createVNode(_unref(Copy), { class: "h-2.5 w-2.5" })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _createVNode(_unref(Badge), { variant: "outline" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(documentTypeLabels[_unref(currentDocument).type]), 1)
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("span", _hoisted_31, [
                                  _createVNode(_unref(Hash), { class: "h-3 w-3" }),
                                  _createTextVNode(" v" + _toDisplayString(_unref(currentDocument).version), 1)
                                ]),
                                _createElementVNode("span", _hoisted_32, [
                                  _createVNode(_unref(Avatar), { class: "h-5 w-5" }, {
                                    default: _withCtx(() => [
                                      (authorUser.value?.avatarUrl)
                                        ? (_openBlock(), _createBlock(_unref(AvatarImage), {
                                            key: 0,
                                            src: authorUser.value.avatarUrl
                                          }, null, 8, ["src"]))
                                        : _createCommentVNode("", true),
                                      _createVNode(_unref(AvatarFallback), { class: "text-[8px]" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(getInitials)(authorUser.value?.displayName)), 1)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" " + _toDisplayString(authorName.value), 1)
                                ]),
                                _createElementVNode("span", _hoisted_33, [
                                  _createVNode(_unref(Calendar), { class: "h-3 w-3" }),
                                  _createTextVNode(" " + _toDisplayString(_unref(formatDate)(_unref(currentDocument).createdAt)), 1)
                                ]),
                                (_unref(currentDocument).viewCount)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                                      _createVNode(_unref(Eye), { class: "h-3 w-3" }),
                                      _createTextVNode(" " + _toDisplayString(_unref(currentDocument).viewCount), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (_unref(currentDocument).version > 1)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, " Actualizado por " + _toDisplayString(updatedByName.value) + " el " + _toDisplayString(_unref(formatDate)(_unref(currentDocument).updatedAt)), 1))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(DocumentReactions, {
                            "document-id": _unref(currentDocument).id,
                            reactions: _unref(currentDocument).reactions,
                            "actor-id": _unref(authStore).userId || ''
                          }, null, 8, ["document-id", "reactions", "actor-id"])
                        ]),
                        (ttsShowPlayer.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                              (ttsIsLoading.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, [
                                      _createVNode(_unref(Loader2), { class: "h-5 w-5 animate-spin text-primary" })
                                    ]),
                                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "flex-1 min-w-0" }, [
                                      _createElementVNode("p", { class: "text-sm font-medium" }, "Generando audio..."),
                                      _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "El documento se está convirtiendo a voz. Esto puede tomar unos segundos."),
                                      _createElementVNode("div", { class: "mt-2 h-1.5 rounded-full bg-muted overflow-hidden" }, [
                                        _createElementVNode("div", { class: "h-full w-1/3 rounded-full bg-primary/30 animate-pulse" })
                                      ])
                                    ], -1)),
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      class: "h-8 w-8 shrink-0",
                                      onClick: closeTtsPlayer
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(X), { class: "h-4 w-4" })
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (ttsError.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                      _createElementVNode("div", _hoisted_41, [
                                        _createVNode(_unref(Volume2), { class: "h-5 w-5 text-destructive" })
                                      ]),
                                      _createElementVNode("div", _hoisted_42, [
                                        _cache[24] || (_cache[24] = _createElementVNode("p", { class: "text-sm font-medium text-destructive" }, "Error", -1)),
                                        _createElementVNode("p", _hoisted_43, _toDisplayString(ttsError.value), 1)
                                      ]),
                                      _createVNode(_unref(Button), {
                                        variant: "outline",
                                        size: "sm",
                                        onClick: startTts
                                      }, {
                                        default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                                          _createTextVNode("Reintentar", -1)
                                        ]))]),
                                        _: 1
                                      }),
                                      _createVNode(_unref(Button), {
                                        variant: "ghost",
                                        size: "icon",
                                        class: "h-8 w-8 shrink-0",
                                        onClick: closeTtsPlayer
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(X), { class: "h-4 w-4" })
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                      _createElementVNode("div", _hoisted_45, [
                                        _createVNode(_unref(Button), {
                                          variant: "default",
                                          size: "icon",
                                          class: "h-9 w-9 rounded-full",
                                          onClick: togglePlayPause
                                        }, {
                                          default: _withCtx(() => [
                                            (ttsIsPlaying.value)
                                              ? (_openBlock(), _createBlock(_unref(Pause), {
                                                  key: 0,
                                                  class: "h-4 w-4"
                                                }))
                                              : (_openBlock(), _createBlock(_unref(Play), {
                                                  key: 1,
                                                  class: "h-4 w-4 ml-0.5"
                                                }))
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_unref(Button), {
                                          variant: "ghost",
                                          size: "icon",
                                          class: "h-8 w-8",
                                          onClick: stopTts
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(Square), { class: "h-3.5 w-3.5" })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _createElementVNode("div", _hoisted_46, [
                                        _createElementVNode("div", {
                                          class: "flex-1 h-1.5 rounded-full bg-muted cursor-pointer relative group",
                                          onClick: seekTts
                                        }, [
                                          _createElementVNode("div", {
                                            class: "h-full rounded-full bg-primary transition-all",
                                            style: _normalizeStyle({ width: `${ttsProgress.value}%` })
                                          }, null, 4),
                                          _createElementVNode("div", {
                                            class: "absolute top-1/2 -translate-y-1/2 h-3 w-3 rounded-full bg-primary opacity-0 group-hover:opacity-100 transition-opacity",
                                            style: _normalizeStyle({ left: `${ttsProgress.value}%`, transform: 'translate(-50%, -50%)' })
                                          }, null, 4)
                                        ]),
                                        _createElementVNode("span", _hoisted_47, _toDisplayString(ttsFormattedTime.value), 1)
                                      ]),
                                      _createVNode(_unref(Button), {
                                        variant: "ghost",
                                        size: "icon",
                                        class: "h-8 w-8 shrink-0",
                                        onClick: closeTtsPlayer
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_unref(X), { class: "h-4 w-4" })
                                        ]),
                                        _: 1
                                      })
                                    ]))
                            ]))
                          : _createCommentVNode("", true),
                        (!contentTooLong.value || hasSummary.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                              (!hasSummary.value && !summaryIsGenerating.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                    _createElementVNode("div", _hoisted_50, [
                                      _createVNode(_unref(Sparkles), { class: "h-4 w-4" }),
                                      _cache[26] || (_cache[26] = _createElementVNode("span", null, "Resumen Copilot", -1))
                                    ]),
                                    _createVNode(_unref(Button), {
                                      variant: "outline",
                                      size: "sm",
                                      onClick: handleGenerateSummary
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(Sparkles), { class: "h-3.5 w-3.5 mr-1.5" }),
                                        _cache[27] || (_cache[27] = _createTextVNode(" Generar resumen ", -1))
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : (summaryIsGenerating.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                                      _createElementVNode("div", _hoisted_52, [
                                        _createVNode(_unref(Loader2), { class: "h-4 w-4 animate-spin text-primary" })
                                      ]),
                                      _cache[28] || (_cache[28] = _createElementVNode("div", { class: "flex-1" }, [
                                        _createElementVNode("p", { class: "text-sm font-medium" }, "Generando resumen..."),
                                        _createElementVNode("p", { class: "text-xs text-muted-foreground" }, "El copilot está analizando el documento")
                                      ], -1))
                                    ]))
                                  : (hasSummary.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                        _createElementVNode("div", _hoisted_54, [
                                          _createElementVNode("button", {
                                            class: "flex items-center gap-2 text-sm font-medium hover:text-foreground transition-colors",
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (summaryCollapsed.value = !summaryCollapsed.value))
                                          }, [
                                            _createVNode(_unref(Sparkles), { class: "h-4 w-4 text-primary" }),
                                            _cache[30] || (_cache[30] = _createElementVNode("span", null, "Resumen Copilot", -1)),
                                            (summaryIsStale.value)
                                              ? (_openBlock(), _createBlock(_unref(Badge), {
                                                  key: 0,
                                                  variant: "outline",
                                                  class: "text-[10px] px-1.5 py-0 text-amber-600 border-amber-300 bg-amber-50 dark:bg-amber-950 dark:border-amber-700 dark:text-amber-400",
                                                  title: "Evalúe si requiere ser regenerado o ignore el mensaje"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(AlertTriangle), { class: "h-2.5 w-2.5 mr-0.5" }),
                                                    _cache[29] || (_cache[29] = _createTextVNode(" Contenido modificado ", -1))
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true),
                                            (_openBlock(), _createBlock(_resolveDynamicComponent(summaryCollapsed.value ? _unref(ChevronDown) : _unref(ChevronUp)), { class: "h-3.5 w-3.5 text-muted-foreground" }))
                                          ]),
                                          _createElementVNode("div", _hoisted_55, [
                                            (summaryIsStale.value)
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  _createVNode(_unref(Button), {
                                                    variant: "ghost",
                                                    size: "sm",
                                                    class: "h-7 text-xs",
                                                    onClick: handleConfirmSummary,
                                                    title: "Marcar resumen como vigente"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(CheckCircle), { class: "h-3.5 w-3.5 mr-1" }),
                                                      _cache[31] || (_cache[31] = _createTextVNode(" Validar ", -1))
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createVNode(_unref(Button), {
                                                    variant: "ghost",
                                                    size: "sm",
                                                    class: "h-7 text-xs",
                                                    onClick: handleGenerateSummary,
                                                    disabled: summaryIsGenerating.value
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_unref(RefreshCw), { class: "h-3.5 w-3.5 mr-1" }),
                                                      _cache[32] || (_cache[32] = _createTextVNode(" Regenerar ", -1))
                                                    ]),
                                                    _: 1
                                                  }, 8, ["disabled"])
                                                ], 64))
                                              : (_openBlock(), _createBlock(_unref(Button), {
                                                  key: 1,
                                                  variant: "ghost",
                                                  size: "sm",
                                                  class: "h-7 text-xs",
                                                  onClick: handleGenerateSummary,
                                                  disabled: summaryIsGenerating.value
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_unref(RefreshCw), { class: "h-3.5 w-3.5 mr-1" }),
                                                    _cache[33] || (_cache[33] = _createTextVNode(" Regenerar ", -1))
                                                  ]),
                                                  _: 1
                                                }, 8, ["disabled"]))
                                          ])
                                        ]),
                                        (!summaryCollapsed.value)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                              _createElementVNode("div", _hoisted_57, [
                                                _createVNode(_unref(MdPreview), {
                                                  "model-value": _unref(currentDocument).copilotSummary!.content,
                                                  language: "en-US"
                                                }, null, 8, ["model-value"])
                                              ]),
                                              _createElementVNode("div", _hoisted_58, " Generado en v" + _toDisplayString(_unref(currentDocument).copilotSummary!.generatedByVersion) + " · " + _toDisplayString(_unref(formatDate)(_unref(currentDocument).copilotSummary!.generatedAt)), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                              (summaryError.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, _toDisplayString(summaryError.value), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_60, [
                          _createVNode(DocumentMarkdownView, {
                            content: _unref(currentDocument).content
                          }, null, 8, ["content"])
                        ])
                      ], 64))
                ]),
                (_unref(currentDocument) && !isMobile.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["shrink-0 border-l transition-all duration-200", commentsPanelCollapsed.value ? 'w-10' : 'w-[380px]'])
                    }, [
                      (commentsPanelCollapsed.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                            _createVNode(_unref(Button), {
                              variant: "ghost",
                              size: "icon",
                              class: "h-8 w-8",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (commentsPanelCollapsed.value = false)),
                              title: "Expandir comentarios"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(PanelRightOpen), { class: "h-4 w-4" })
                              ]),
                              _: 1
                            })
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                              _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-sm font-medium" }, "Comentarios", -1)),
                              _createVNode(_unref(Button), {
                                variant: "ghost",
                                size: "icon",
                                class: "h-8 w-8",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (commentsPanelCollapsed.value = true)),
                                title: "Contraer comentarios"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_unref(PanelRightClose), { class: "h-4 w-4" })
                                ]),
                                _: 1
                              })
                            ]),
                            _createElementVNode("div", _hoisted_64, [
                              _createVNode(CommentsList, {
                                "entity-type": "document",
                                "entity-id": _unref(currentDocument).id
                              }, null, 8, ["entity-id"])
                            ])
                          ]))
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              (isMobile.value && _unref(currentDocument))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("button", {
                        class: "w-full flex items-center justify-between px-4 py-2.5 text-sm font-medium hover:bg-muted/50 transition-colors",
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (searchPanelCollapsed.value = !searchPanelCollapsed.value))
                      }, [
                        _createElementVNode("span", _hoisted_66, [
                          _createVNode(_unref(Search), { class: "h-4 w-4" }),
                          _cache[35] || (_cache[35] = _createTextVNode(" Buscar documentos ", -1))
                        ]),
                        (_openBlock(), _createBlock(_resolveDynamicComponent(searchPanelCollapsed.value ? _unref(ChevronDown) : _unref(ChevronUp)), { class: "h-4 w-4 text-muted-foreground" }))
                      ]),
                      (!searchPanelCollapsed.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                            _createElementVNode("div", _hoisted_68, [
                              _createVNode(_unref(Search), { class: "absolute left-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" }),
                              _createVNode(_unref(Input), {
                                modelValue: searchQuery.value,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((searchQuery).value = $event)),
                                placeholder: "Buscar documentos...",
                                class: "pl-8 h-8 text-sm",
                                onKeydown: _withKeys(doSearch, ["enter"])
                              }, null, 8, ["modelValue"])
                            ]),
                            _createVNode(_unref(Select), {
                              modelValue: entityFilter.value,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((entityFilter).value = $event))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_unref(SelectTrigger), { class: "h-8 text-sm" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(SelectValue))
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_unref(SelectContent), { class: "z-[200]" }, {
                                  default: _withCtx(() => [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(entityTypeOptions, (opt) => {
                                      return _createVNode(_unref(SelectItem), {
                                        key: opt.value,
                                        value: opt.value
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(opt.label), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"])
                                    }), 64))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_unref(Button), {
                              size: "sm",
                              class: "w-full h-8",
                              onClick: doSearch,
                              disabled: isSearching.value
                            }, {
                              default: _withCtx(() => [
                                (isSearching.value)
                                  ? (_openBlock(), _createBlock(_unref(Loader2), {
                                      key: 0,
                                      class: "h-3.5 w-3.5 mr-1.5 animate-spin"
                                    }))
                                  : (_openBlock(), _createBlock(_unref(Search), {
                                      key: 1,
                                      class: "h-3.5 w-3.5 mr-1.5"
                                    })),
                                _cache[36] || (_cache[36] = _createTextVNode(" Buscar ", -1))
                              ]),
                              _: 1
                            }, 8, ["disabled"]),
                            (isSearching.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                                  _createVNode(_unref(Loader2), { class: "h-5 w-5 animate-spin text-muted-foreground" })
                                ]))
                              : (hasSearched.value && searchResults.value.length === 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_70, [...(_cache[37] || (_cache[37] = [
                                    _createElementVNode("p", { class: "text-sm text-muted-foreground" }, "Sin resultados", -1)
                                  ]))]))
                                : (searchResults.value.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchResults.value, (doc) => {
                                        return (_openBlock(), _createElementBlock("button", {
                                          key: doc.id,
                                          class: _normalizeClass(["w-full text-left py-2 hover:bg-muted/50 transition-colors flex items-start gap-2", { 'bg-muted': _unref(currentDocument)?.id === doc.id }]),
                                          onClick: ($event: any) => {selectDocument(doc); searchPanelCollapsed.value = true}
                                        }, [
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["h-7 w-7 rounded flex items-center justify-center text-white shrink-0", documentTypeColors[doc.type]])
                                          }, [
                                            _createVNode(_unref(FileText), { class: "h-3.5 w-3.5" })
                                          ], 2),
                                          _createElementVNode("div", _hoisted_73, [
                                            _createElementVNode("p", _hoisted_74, _toDisplayString(doc.title), 1),
                                            _createElementVNode("p", _hoisted_75, _toDisplayString(entityTypeLabels[doc.entityType] || doc.entityType) + " · " + _toDisplayString(_unref(formatDate)(doc.updatedAt)), 1)
                                          ])
                                        ], 10, _hoisted_72))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_76, [
                      _createElementVNode("button", {
                        class: "w-full flex items-center justify-between px-4 py-2.5 text-sm font-medium hover:bg-muted/50 transition-colors",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (commentsPanelCollapsed.value = !commentsPanelCollapsed.value))
                      }, [
                        _createElementVNode("span", _hoisted_77, [
                          _createVNode(_unref(FileText), { class: "h-4 w-4" }),
                          _cache[38] || (_cache[38] = _createTextVNode(" Comentarios ", -1))
                        ]),
                        (_openBlock(), _createBlock(_resolveDynamicComponent(commentsPanelCollapsed.value ? _unref(ChevronDown) : _unref(ChevronUp)), { class: "h-4 w-4 text-muted-foreground" }))
                      ]),
                      (!commentsPanelCollapsed.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                            _createVNode(CommentsList, {
                              "entity-type": "document",
                              "entity-id": _unref(currentDocument).id
                            }, null, 8, ["entity-id"])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})